import { useState, useEffect, useRef } from "react";
import { debugLog } from "../../../../configs/loggingConfig";

export const usePromptEditor = (chatTemplate, setChatTemplate, formIsPrepared, setFormIsPrepared) => {
    // The prompt input field.
    const [prompt, setPrompt] = useState("");
    const [promptIsReady, setPromptIsReady] = useState(false);

    const placeholderPrompt = "As a technical recruiter, draft a job description for a [Job Title]. Some of the responsibilities will include [writing some codes]. The requirements for this job include [e.g. 10 years of experience]. The job is located in [e.g. Allentown, PA]. This job is {On-site, Hybrid, Remote}"

    const createStringFromPromptParts = (parts) => {
        let newPrompt = parts?.map((component) => {
            if (component.componentType === "input") {
                return `[${component.text}]`;
            } else if (component.componentType === "textarea") {
                return `[[${component.text}]]`
            } else if (component.componentType === "select") {
                return `{${
                    component.options.map((option) => {
                        let optionStr = option
                        if (option === component.defaultValue) {
                            optionStr += "*"
                        }
                        return optionStr || "";
                    })
                }}`
            } else {
                return component.text;
            }
        }).join("");

        return newPrompt;
    }

    // Initialize prompt from existing template
    useEffect(() => {
        if (chatTemplate?.messageComponents?.length !== 0) {
            debugLog.log("[A] OLD!");
            let newPrompt = createStringFromPromptParts(chatTemplate?.messageComponents)
            setPromptIsReady(newPrompt !== undefined);
            updatePrompt(newPrompt);
        } else {
            debugLog.log("[A] NEW!");
            setPromptIsReady(true);
            updatePrompt(placeholderPrompt);
        }
    }, [])
    
    useEffect(() => {
        if (!promptIsReady && chatTemplate?.id) {
            debugLog.log("[A] NEW NOT READY!");
            let newPrompt = createStringFromPromptParts(chatTemplate?.messageComponents)
            setPromptIsReady(newPrompt !== undefined);
            updatePrompt(newPrompt);
        }
    }, [chatTemplate])

    // This will handle both updating the state of prompt and the updating of the prompt message components.
    const updatePrompt = (newPrompt) => {
        const bracketRegex = /(\[\[.*?\]\]|\[.*?\]|\{.*?\})/g;

        if (newPrompt == null || newPrompt == undefined) return;
        setPrompt(newPrompt);

        // Separating the prompt into a list of items that are either text, inputs, selects, or text areas.
        let promptPieces = newPrompt.split(bracketRegex);
        let promptObj = []

        if (newPrompt != "") {
            promptObj = promptPieces.map((part, index) => {
                if (part.startsWith('[[') && part.endsWith(']]')) {
                    return { 
                        type: 'textarea', 
                        text: part.slice(2, -2),
                        value: "",
                        messageOrder: index,
                    };
                } else if (part.startsWith('[') && part.endsWith(']')) {
                    return { 
                        type: 'input', 
                        text: part.slice(1, -1),
                        value: "",
                        messageOrder: index,
                    };
                } else if (part.startsWith('{') && part.endsWith('}')) {
                    let selectOptions = part.slice(1, -1).split(",").map((item) => item.trim());
                    return { 
                        type: 'select', 
                        options: [...selectOptions.map((option) => option.endsWith('*') ? option.slice(0, -1) : option)],
                        defaultValue: selectOptions.find((input) => input.endsWith('*'))?.slice(0, -1) || null,
                        value: selectOptions.find((input) => input.endsWith('*'))?.slice(0, -1) || "",
                        messageOrder: index,
                    };
                } else {
                    return { 
                        type: 'text', 
                        text: part,
                        value: part,
                        messageOrder: index,
                    };
                }
            });

            // The above REGEX will make it so the last item will ALWAYS be a text item. If it's blank, remove it!
            if (promptObj[promptObj.length - 1].value === "") {
                promptObj = promptObj.slice(0, -1);
            }
        }

        let newTemplateObj = {...chatTemplate}
        newTemplateObj.messageComponents = newPrompt === "" ? [] : [...promptObj];
        setChatTemplate({...newTemplateObj});
    }

    return {
        prompt,
        updatePrompt,
    };
};
